import React from 'react'; 
import Image from '../global/Image';
import NewsGallery from './NewsGallery';
import { Link } from 'react-router-dom';
import WithConsumer from '../../context/WithConsumer';

const NewsArticle = ({ context }) => {

    const posts = () => context.posts;
    const post = posts()[0];
	
	const ctxPageLoaded = () => context.pageLoaded;
    const pageLoaded = ctxPageLoaded();
    
    let ctxPrevSlug = () => context.prevSlug;
	let prev = ctxPrevSlug();
	
	if (prev == '/' || prev == '' || prev == false) {
		prev = '/news/';
	}
	
	console.log('prev: ' + prev);
     
    if (post) {
	    
	    let pageClass = 'c-page c-page--space c-article c-page--' + post.slug;
	    
	    if (pageLoaded) {
		    pageClass = pageClass + ' state-page-loaded';
	    }
	    						
		return (
			
			<div className={pageClass}>
				
				<div className="c-page__inner c-page__inner--no-space">
					
					{post.heading &&
										    			    		
			    		<div className="c-page__header c-page__block--load-effect">
			    		
			    			<Link to={{ pathname: prev }} className="c-project__header__back" dangerouslySetInnerHTML={{__html:'<svg width="28" height="6" viewBox="0 0 28 6"><path d="M0 3L5 5.88675V0.113249L0 3ZM28 2.5L4.5 2.5V3.5L28 3.5V2.5Z" /></svg>Back to news'}}></Link>
					
							<h1 className="c-page__header__large-heading" dangerouslySetInnerHTML={{__html: post.heading}}></h1>		
														
						</div>
					    					    					    
					}
					
					{post.gllry &&
						
						<>
							
							{post.gllry.length > 1 &&
								
								<div className="c-page__block c-page__block--max-width c-page__block--space-standard c-page__block--load-effect">
			 
									<div className="l-grid">
									
										<div className="l-grid__col">
										
											<NewsGallery gallery={post.gllry}></NewsGallery>
											
										</div>
										
									</div>
									
								</div>
								
							}
							
							{post.gllry.length === 1 &&
								
								<div className="c-page__block c-page__block--max-width c-page__block--space-standard c-page__block--load-effect">
			 
									<div className="l-grid">
									
										<div className="l-grid__col">
																							
											<div className="c-image c-image--full">
											
												{post.gllry[0].width > post.gllry[0].height &&
													
													<Image width={post.gllry[0].width} height={post.gllry[0].height} srcset={post.gllry[0].srcset} src={post.gllry[0].src} />
							
												}
												
												{post.gllry[0].width <= post.gllry[0].height &&
													
													<div className="c-article__image">
														<Image  srcset={post.gllry[0].srcset} src={post.gllry[0].src} />
													</div>
							
												}
																		
											</div>
																						
										</div>
									
									</div>
									
								</div>
								
							}
						</>
						
					}
					
					<div className="c-page__block c-page__block--inset-mobile c-page__block--max-width c-page__block--space-large c-page__block--load-effect">
			    			    		
			    		<div className="l-grid">
			    		
			    			<div className="l-grid__col">
			    			
			    				<div className="c-text c-text--right">
			    				
			    					<div className="scope-text scope-text--faded" dangerouslySetInnerHTML={{__html:post.content}}></div>
			    								    					
			    				</div>	
			    										
							</div>
			    			
			    		</div>
				    					    
				    </div>
				    
				</div>
				
			</div>
		)
		
	} else {
		return null;
	}
};
export default WithConsumer(NewsArticle);